import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import BorsamexLogo, { 
  LogoVariant1, 
  LogoVariant2, 
  LogoVariant3, 
  LogoVariant4, 
  LogoVariant5 
} from '../components/BorsamexLogo';

const LogoShowcase = () => {
  const logos = [
    { name: 'Varyasyon 1', desc: 'Minimalist Trend + Ok', Component: LogoVariant1 },
    { name: 'Varyasyon 2', desc: 'Gradient + Veri Noktaları', Component: LogoVariant2 },
    { name: 'Varyasyon 3', desc: 'Keskin Trend + Ok', Component: LogoVariant3 },
    { name: 'Varyasyon 4', desc: 'Ultra Minimalist', Component: LogoVariant4 },
    { name: 'Varyasyon 5', desc: 'Alan Grafiği', Component: LogoVariant5 },
  ];

  return (
    <div className="min-h-screen bg-brand-dark py-12">
      <div className="container mx-auto px-6">
        <h1 className="text-4xl font-bold text-white text-center mb-4">
          Borsamex Logo Tasarımları
        </h1>
        <p className="text-slate-400 text-center mb-12">
          Minimalist trend çizgisi logo varyasyonları
        </p>

        {/* Logo Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {logos.map((logo, idx) => (
            <Card key={idx} className="border-slate-800 bg-slate-900/50 hover:bg-slate-800/50 transition-all">
              <CardContent className="p-8">
                <div className="flex flex-col items-center">
                  {/* Logo büyük */}
                  <div className="mb-6">
                    <logo.Component size={80} />
                  </div>
                  
                  {/* Logo küçük boyutlar */}
                  <div className="flex items-center gap-4 mb-4">
                    <logo.Component size={48} />
                    <logo.Component size={32} />
                    <logo.Component size={24} />
                  </div>

                  <h3 className="text-lg font-bold text-white">{logo.name}</h3>
                  <p className="text-sm text-slate-400">{logo.desc}</p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Navbar Preview */}
        <div className="mt-16">
          <h2 className="text-2xl font-bold text-white text-center mb-8">
            Navbar Önizleme
          </h2>
          
          <div className="space-y-4 max-w-4xl mx-auto">
            {logos.map((logo, idx) => (
              <div key={idx} className="bg-brand-dark/80 border border-slate-800 rounded-xl p-4">
                <div className="flex items-center space-x-3">
                  <logo.Component size={40} />
                  <span className="text-2xl font-heading font-bold">
                    <span className="text-white">Borsa</span>
                    <span className="text-primary">mex</span>
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Karanlık/Aydınlık Karşılaştırma */}
        <div className="mt-16">
          <h2 className="text-2xl font-bold text-white text-center mb-8">
            Arka Plan Uyumu
          </h2>
          
          <div className="grid grid-cols-2 gap-4 max-w-2xl mx-auto">
            {/* Koyu arka plan */}
            <div className="bg-[#0A0F14] rounded-xl p-8 flex flex-col items-center">
              <LogoVariant2 size={64} />
              <span className="text-slate-400 text-sm mt-4">Koyu Tema</span>
            </div>
            
            {/* Açık arka plan */}
            <div className="bg-slate-100 rounded-xl p-8 flex flex-col items-center">
              <LogoVariant2 size={64} />
              <span className="text-slate-600 text-sm mt-4">Açık Tema</span>
            </div>
          </div>
        </div>

        {/* Favori Seçimi */}
        <div className="mt-16 text-center">
          <p className="text-slate-400 mb-4">
            Beğendiğiniz varyasyonu söyleyin, Navbar'a uygulayayım!
          </p>
          <div className="flex justify-center gap-4 flex-wrap">
            {[1, 2, 3, 4, 5].map(num => (
              <div key={num} className="flex flex-col items-center p-4 rounded-xl bg-slate-800/50 hover:bg-primary/20 cursor-pointer transition-all">
                <BorsamexLogo variant={num} size={48} />
                <span className="text-white text-sm mt-2">#{num}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogoShowcase;
